import { format } from 'date-fns';

export const formatDate = (date: Date) => {
  const dateString = format(date, 'dd/M/yyyy');
  const time = format(date, " k'h'mm");

  return {
    date: dateString,
    time,
  };
};
